import { render, staticRenderFns } from "./HeaderTitle.vue?vue&type=template&id=56c17bbe&scoped=true&"
import script from "./HeaderTitle.vue?vue&type=script&lang=js&"
export * from "./HeaderTitle.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTitle.vue?vue&type=style&index=0&id=56c17bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c17bbe",
  null
  
)

export default component.exports